import {firebase} from '../config/fbconfig';
import { trackPromise } from "react-promise-tracker";
import { getTeamById } from "../services/userServices";


var storageRef = firebase.storage().ref();
var metadata = {
    contentType: 'image/jpeg'
};
const db = firebase.firestore();
class Events{
    static async ListAllUsers() {
        const snapshot = await db.collection('chromaUsers').orderBy("email","desc").get()
        return snapshot.docs.map(doc => doc.data());
    }
    static async deleteAuthUser(userid) {
        const snapshot = db.collection('chromaUsers').where('UID', '==', userid);
        snapshot.get().then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
                doc.ref.delete().then((success) => {
                    return success;
                  }).catch(function(error) {
                   return error;
                  });
            });
        });
    }
     static async addEvents(eventsData,id){
        //var file1 = document.querySelector('input[id=team1]').files[0];
        // var file2 = document.querySelector('input[id=eventPhoto]').files[0];
        var file3 = document.querySelector('input[id=stadiumImage]').files[0];
        //let team1DownloadURL = ((eventsData.team1LogoURL !== '' && eventsData.team1LogoURL.length !== 0) ? eventsData.team1LogoURL : await this.UploadImage(file1));
        // let eventPhotoURL = await this.UploadImage(file2);
        let stadiumImageURL = await this.UploadImage(file3);
        return new Promise((resolve, reject) => {
            let MyFinalData = {
                eventName: eventsData.eventName,
                eventStadiumLocation: eventsData.stadiumLoc,
                time_zone: eventsData.time_zone,
                eventDate: eventsData.eventDate,
                eventendDate: eventsData.eventendDate,
                eventTime: eventsData.eventTime,
                endTime: eventsData.endTime,
                //team2Name: eventsData.team2Name,
                //team1Name: eventsData.team1Name,
                //team1LogoName: eventsData.team1LogoName,
                //team1LogoURL:team1DownloadURL,
                // eventPhotoURL:eventPhotoURL,
                stadiumImageURL:stadiumImageURL,
                team1Hex1: eventsData.team1Hex1,
                team1Hex2: eventsData.team1Hex2,
                fileName:eventsData.fileName,
                seatKeys:eventsData.seatKeys,
                seatsJSON:eventsData.seatsJSON
            }
            if(eventsData.team1Hex1){
                db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
                    eventHex1: eventsData.team1Hex1,
                }, { merge: true });
            }
            if(eventsData.team1Hex2){
                db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
                    eventHex2: eventsData.team1Hex2
                }, { merge: true });
            }
            // if(eventsData.team1Name){
            //     db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
            //         eventTeamName: eventsData.team1Name
            //     }, { merge: true });
            // }
            // if(team1DownloadURL){
            //     db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
            //         team_logo: team1DownloadURL
            //     }, { merge: true });
            // }
            db.collection('teams').doc(id).collection('events').add(MyFinalData).then(ref => {
                ref.set({
                    id: ref.id
                }, {
                    merge: true
                }).then(async() => {
                
                    trackPromise(
                        getTeamById(id).then(response => {
                        console.log("response", response[0].events);
                        let emptyEvents=[];
                        let  newEvents=[];
                        if(response[0].events){
                         newEvents =  emptyEvents.concat(response[0].events);
                        }
                        console.log("new List", newEvents);
                        let event = {
                            'event_id':ref.id,
                            'event_end_date': eventsData.eventendDate,
                            'event_end_time' : eventsData.endTime,
                            'time_zone' : eventsData.time_zone
                        }
                        newEvents.push(event);
                        if(eventsData.eventendDate){
                            db.collection('teams').doc(id).set({
                                events: newEvents
                            }, { merge: true });
                        }
 
                      })
                    ).catch(error => {
                      console.log(error);
                    });
                    
                    const snapshot = await db.collection('teams').doc(id).collection('events').get()
                    return resolve(snapshot.docs.map(doc => doc.data()));
                }, (err) => {
                    return reject(err);
                })
            });
        });
    }

    // static async addEventsInTeams(eventsData,id){
    //     console.log("Here.")
    //     var file1 = document.querySelector('input[id=team1]').files[0];
    //     // var file2 = document.querySelector('input[id=eventPhoto]').files[0];
    //     var file3 = document.querySelector('input[id=stadiumImage]').files[0];
    //     let team1DownloadURL = ((eventsData.team1LogoURL !== '' && eventsData.team1LogoURL.length !== 0) ? eventsData.team1LogoURL : await this.UploadImage(file1));
    //     // let eventPhotoURL = await this.UploadImage(file2);
    //     let stadiumImageURL = await this.UploadImage(file3);
    //     return new Promise((resolve, reject) => {
    //         let MyFinalData = {
    //             eventName: eventsData.eventName,
    //             eventStadiumLocation: eventsData.stadiumLoc,
    //             time_zone: eventsData.time_zone,
    //             eventDate: eventsData.eventDate,
    //             eventendDate: eventsData.eventendDate,
    //             eventTime: eventsData.eventTime,
    //             endTime: eventsData.endTime,
    //             team2Name: eventsData.team2Name,
    //             team1Name: eventsData.team1Name,
    //             team1LogoName: eventsData.team1LogoName,
    //             team1LogoURL:team1DownloadURL,
    //             // eventPhotoURL:eventPhotoURL,
    //             stadiumImageURL:stadiumImageURL,
    //             team1Hex1: eventsData.team1Hex1,
    //             team1Hex2: eventsData.team1Hex2,
    //             fileName:eventsData.fileName,
    //             seatKeys:eventsData.seatKeys,
    //             seatsJSON:eventsData.seatsJSON
    //         }
    //         if(eventsData.team1Hex1){
    //             db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
    //                 eventHex1: eventsData.team1Hex1,
    //             }, { merge: true });
    //         }
    //         if(eventsData.team1Hex2){
    //             db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
    //                 eventHex2: eventsData.team1Hex2
    //             }, { merge: true });
    //         }
    //         if(eventsData.team1Name){
    //             db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
    //                 eventTeamName: eventsData.team1Name
    //             }, { merge: true });
    //         }
    //         if(team1DownloadURL){
    //             db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
    //                 team_logo: team1DownloadURL
    //             }, { merge: true });
    //         }
    //         db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('events').add(MyFinalData).then(ref => {
    //             ref.set({
    //                 id: ref.id
    //             }, {
    //                 merge: true
    //             }).then(async() => {
    //                 const snapshot = await db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('events').get()
    //                 return resolve(snapshot.docs.map(doc => doc.data()));
    //             }, (err) => {
    //                 return reject(err);
    //             })
    //         });
    //     });
    // }
    static async addEventsTeams(eventsData){
        var file1 = document.querySelector('input[id=team1]').files[0];
        // var file2 = document.querySelector('input[id=eventPhoto]').files[0];
        var file3 = document.querySelector('input[id=stadiumImage]').files[0];
        let team1DownloadURL = ((eventsData.team1LogoURL !== '' && eventsData.team1LogoURL.length !== 0) ? eventsData.team1LogoURL : await this.UploadImage(file1));
        // let eventPhotoURL = await this.UploadImage(file2);
        let stadiumImageURL = await this.UploadImage(file3);
        return new Promise((resolve, reject) => {
            let MyFinalData = {
                eventName: eventsData.eventName,
                eventStadiumLocation: eventsData.stadiumLoc,
                time_zone: eventsData.time_zone,
                eventDate: eventsData.eventDate,
                eventendDate: eventsData.eventendDate,
                eventTime: eventsData.eventTime,
                endTime: eventsData.endTime,
                team2Name: eventsData.team2Name,
                team1Name: eventsData.team1Name,
                team1LogoName: eventsData.team1LogoName,
                team1LogoURL:team1DownloadURL,
                // eventPhotoURL:eventPhotoURL,
                stadiumImageURL:stadiumImageURL,
                team1Hex1: eventsData.team1Hex1,
                team1Hex2: eventsData.team1Hex2,
                fileName:eventsData.fileName,
                seatKeys:eventsData.seatKeys,
                seatsJSON:eventsData.seatsJSON
            }
            if(eventsData.team1Hex1){
                db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
                    eventHex1: eventsData.team1Hex1,
                }, { merge: true });
            }
            if(eventsData.team1Hex2){
                db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
                    eventHex2: eventsData.team1Hex2
                }, { merge: true });
            }
            if(eventsData.team1Name){
                db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
                    eventTeamName: eventsData.team1Name
                }, { merge: true });
            }
            if(team1DownloadURL){
                db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
                    team_logo: team1DownloadURL
                }, { merge: true });
            }
            db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('events').add(MyFinalData).then(ref => {
                ref.set({
                    id: ref.id
                }, {
                    merge: true
                }).then(async() => {
                    const snapshot = await db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('events').get()
                    return resolve(snapshot.docs.map(doc => doc.data()));
                }, (err) => {
                    return reject(err);
                })
            });
        });
    }
    static async getEvents() {
        const snapshot = await db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('events').get()
        return snapshot.docs.map(doc => doc.data());
    }

    static async getEventsByTeam(teamId) {
        const snapshot = await db.collection('teams').doc(teamId).collection('events').get()
        return snapshot.docs.map(doc => doc.data());
    }

    static async getSingleEvent(teamId,eventId) {
        console.log("teamId",teamId);
        console.log("eventId",eventId);
        const snapshot = await db.collection('teams').doc(teamId).collection('events').where('id', '==', eventId).get()
        return snapshot.docs.map(doc => doc.data());

    }
    static UploadImage(file){
        return new Promise((resolve, reject) => {
            var uploadTask = storageRef.child('images/' + file.name).put(file, metadata);
            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                function (snapshot) {
                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    // console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        // console.log('Upload is paused');
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        // console.log('Upload is running');
                        break;
                    default:
                        {

                        }
                    }
                },
                function (error) {
                    switch (error.code) {
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;

                    case 'storage/canceled':
                        // User canceled the upload
                        break;

                    case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                    default:
                        {

                        }
                    }
                },
                function () {
                    // Upload completed successfully, now we can get the download URL
                    uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                            resolve(downloadURL) ;
                    }) 
                })
                return uploadTask.snapshot.ref.getDownloadURL()
        });
        
    }
    
    static DeleteData(DataId) {
        return new Promise((resolve, reject) => {
            db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).update({
                eventHex1:'',
                eventHex2:''
            })
            db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('events').doc(DataId).delete().then(async() => {
                const snapshot = await db.collection('events').get()
                return resolve(snapshot.docs.map(doc => doc.data()));
            }, (err) => {
                return reject(err);
            });
        })

    }

    static deleteEventInTeams(DataId,teamId) {
        return new Promise((resolve, reject) => {
            db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).update({
                eventHex1:'',
                eventHex2:''
            })
            db.collection('teams').doc(teamId).collection('events').doc(DataId).delete().then(async() => {

                trackPromise(
                    getTeamById(teamId).then(response => {
                    console.log("response", response[0].events);
                    let emptyEvents=[];
                    let  newEvents=[];
                    if(response[0].events){
                     newEvents =  emptyEvents.concat(response[0].events);
                    }
                    let new_newEvents = newEvents.filter(e => e.event_id != DataId)
                        db.collection('teams').doc(teamId).set({
                            events: new_newEvents
                        }, { merge: true });

                  })
                ).catch(error => {
                  console.log(error);
                });


                const snapshot = await db.collection('events').get()
                return resolve(snapshot.docs.map(doc => doc.data()));
            }, (err) => {
                return reject(err);
            });
        })

    }

    static async UpdateEvents(teamId,DataId, Data) {
        let team1logo = document.querySelector('input[id=EditTeam1Logo]').files[0];
        // let eventPhoto = document.querySelector('input[id=EditeventPhoto]').files[0];
        let stadiumImage = document.querySelector('input[id=Lighshow]').files[0];
        var Updateteam1LogoURL = ( team1logo == undefined ? Data.team1LogoURL : await this.UploadImage(team1logo) );
        // var UpdateEventPhotoURL = ( eventPhoto == undefined ? Data.eventPhotoURL : await this.UploadImage(eventPhoto) );
        var UpdateStadiumImageURL = ( stadiumImage == undefined ? Data.stadiumImageURL : await this.UploadImage(stadiumImage) );
        //Data.team1LogoURL = Updateteam1LogoURL;
        Data.stadiumImageURL = UpdateStadiumImageURL;
        // Data.eventPhotoURL = UpdateEventPhotoURL
        return new Promise((resolve, reject) => {
            if(Data.team1Hex1){
                db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).update({ 
                    eventHex1: Data.team1Hex1, 
                });
            }
            if(Data.team1Hex2){
                db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).update({ 
                    eventHex2: Data.team1Hex2, 
                });
            }
            
            db.collection('teams').doc(teamId).collection('events').doc(DataId).update(Data).then(async() => {

                trackPromise(
                    getTeamById(teamId).then(response => {
                    console.log("response", response[0].events);
                    let emptyEvents=[];
                    let  newEvents=[];
                    if(response[0].events){
                     newEvents =  emptyEvents.concat(response[0].events);
                    }
                    console.log("new List", newEvents);
                    for( let i=0; i <newEvents.length ; i++){
                       if(newEvents[i].event_id == DataId)
                       {
                        newEvents[i].event_end_date = Data.eventendDate;
                        newEvents[i].event_end_time = Data.endTime;
                        newEvents[i].time_zone =Data.time_zone;
                       }
                    }
                        db.collection('teams').doc(teamId).set({
                            events: newEvents
                        }, { merge: true });

                  })
                ).catch(error => {
                  console.log(error);
                });

                const snapshot = await db.collection('events').get()
                return resolve(snapshot.docs.map(doc => doc.data()));
            }, (err) => {
                return reject(err);
            })
        })
    }
}
export default Events
